import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomMessageModel } from '../../../types';
import { CustomMessageComponent } from './custom-message.component';

@Injectable({
  providedIn: 'root'
})
export class CustomMessageService {

  dialogRef: any;
  response: boolean = false;


  constructor(
    private dialog: MatDialog,
  ) {}
  
  open(data: CustomMessageModel) {
    this.dialogRef = this.dialog.open(CustomMessageComponent, {
      disableClose: true,
      minWidth: '200px',
      maxWidth: '400px',
      data: data
    });

    return new Promise ((resolve)=>{

      this.dialogRef.afterClosed().subscribe((result: boolean)=> {
        resolve(result);
      });
    });
  }

  close() {
    this.dialogRef.close();
  }

}
